/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsUserSubscriptionPendingChanges
 */
export interface MelcoModelsUserSubscriptionPendingChanges {
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsUserSubscriptionPendingChanges
     */
    sub_start_date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserSubscriptionPendingChanges
     */
    change_from?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserSubscriptionPendingChanges
     */
    change_to?: string | null;
}

export function MelcoModelsUserSubscriptionPendingChangesFromJSON(json: any): MelcoModelsUserSubscriptionPendingChanges {
    return MelcoModelsUserSubscriptionPendingChangesFromJSONTyped(json, false);
}

export function MelcoModelsUserSubscriptionPendingChangesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsUserSubscriptionPendingChanges {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sub_start_date': !exists(json, 'sub_start_date') ? undefined : (json['sub_start_date'] === null ? null : new Date(json['sub_start_date'])),
        'change_from': !exists(json, 'change_from') ? undefined : json['change_from'],
        'change_to': !exists(json, 'change_to') ? undefined : json['change_to'],
    };
}

export function MelcoModelsUserSubscriptionPendingChangesToJSON(value?: MelcoModelsUserSubscriptionPendingChanges | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sub_start_date': value.sub_start_date === undefined ? undefined : (value.sub_start_date === null ? null : value.sub_start_date.toISOString()),
        'change_from': value.change_from,
        'change_to': value.change_to,
    };
}


